module.exports = __webpack_public_path__ + "static/img/btn-call.bf9f17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/btn-call.png
// module id = +Rzq
// module chunks = 1